import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { authService } from '../services/auth.service';
import { useToastNotification } from '../utils/toast-utils';

export const useAuth = () => {
  const { showToast } = useToastNotification();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(authService.getUser());
  const history = useHistory();
  const [showDocumentModal, setShowDocumentModal] = useState(false);

  const register = async (userData) => {
    try {
      setLoading(true);
      setError(null);
      const response = await authService.register(userData);
      history.push('/auth/sign-in');
      return response;
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      setLoading(true);
      setError(null);
      console.log('Attempting login...');
      const response = await authService.login(email, password);
      console.log('Login response:', response);
      
      // Check document verification status
      if (response.user?.documentVerificationStatus === 'PENDING') {
        setShowDocumentModal(true);
      } else if (response.user?.documentVerificationStatus === 'WAITING_FOR_APPROVAL') {
        // Show approval modal if needed
        setShowDocumentModal(false);
      }
      
      // Redirect based on user role
      if (response.user?.role === 'ADMIN') {
        history.push('/admin/user-management');
      } else {
        history.push('/user/profile');
      }
      
      return response;
    } catch (err) {
      console.log('Login error:', err);
      const errorMessage = err.message || err.response?.data?.message || 'Login failed';
      console.log('Error message:', errorMessage);
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    authService.logout();
    setUser(null);
    history.push('/auth/sign-in');
  };

  return { login, register, logout, error, loading, user };
};
